import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import axios from 'axios';
import HeaderLogin from '../../main/nav-login/HeaderLogin';
import Footer from '../../main/nav/Footer';
import Jurnal from '../component/Publikasi';

const fetchers = {
    jurnal: (id) => axios.get(`/jurnal-get/${id}`),
    seminar: (id) => axios.get(`/workshop-get/${id}`),
    buku: (id) => axios.get(`/buku-get/${id}`),
    paten: (id) => axios.get(`/paten-get/${id}`),
    prosiding: (id) => axios.get(`/prosiding-get/${id}`),
    laporan: (id) => axios.get(`/nonpublish-get/${id}`),
    nonpublish: (id) => axios.get(`/nonpublish-get/${id}`),
    opini: (id) => axios.get(`/opini-get/${id}`),
    karya: (id) => axios.get(`/karya-get/${id}`),
    poster: (id) => axios.get(`/poster-get/${id}`),
};

export default function PublikasiP() {
    const { id, state } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [publikasi, setPublikasi] = useState([]);
    const normalizedState = state?.toString().toLowerCase();

    const gotoGrafik = () => {
        navigate('/');
    };

    const fetchData = async () => {
        const { data } = await axios.get('/data-get');
        if (data) {
            setData(data);
        }
    };

    const fetchPublikasi = async () => {
        const fetcher = fetchers[normalizedState];
        if (!fetcher) {
            setPublikasi([]);
            return;
        }

        const response = await fetcher(id);
        if (response.data) {
            setPublikasi(response.data);
        }
    };

    useEffect(() => {
        fetchData();
        fetchPublikasi();
    }, [id, normalizedState]);

    return (
        <div className="min-h-screen bg-slate-50 text-brand-navy">
            <HeaderLogin data={data} grafik={gotoGrafik} />
            <Jurnal data={publikasi} state={state} />
            <div className="bg-brand-navy text-white">
                <Footer />
            </div>
        </div>
    );
}
